import React, { useContext, useState } from "react";
import Modal from "react-modal";
import DataFetch from "../../../../../../../images/OpenIcon.svg";
import { AppContext } from "../../../../../../../context/context";
import SuppliersAutocomplete from "./SuppliersAutocomplete";
import { payloadTypes } from "../../../../../../../context/reducer";
import { AddModalStyles } from "../../../../../../../styles/CustomModalStyles";
import SuppliersList from "./SupplierList";
import { responseType } from "../../../../../../../utils/formTypes";
import { LdgrQueryData, LdgrQueryType } from "../../../../masters/supplier/queries/types";
import { TableType } from "../../../../../customer/companies/queries/types";

export interface SuppplierSelectProps {
  onKeyDown?:
    | ((
        event: React.KeyboardEvent<HTMLDivElement> & {
          defaultMuiPrevented?: boolean;
        }
      ) => void)
    | undefined;
  onChange?: (newValue: responseType) => void;
  value?: number;
  autoFocus?: boolean;
  label?: string;
  forPo?: boolean;
  placeholder?: string;
  icon?: boolean;
  input: LdgrQueryData;
}
const SuppliersSelect = ({
  autoFocus,
  onChange,
  onKeyDown,
  value,
  label,
  forPo,
  icon,
  input,
}: SuppplierSelectProps) => {
  const { state, dispatch } = useContext(AppContext);
  const [itemModal, setItemModal] = useState(false);

  const handleChange = (newValue: responseType) => {
    if (newValue) {
      dispatch({
        type: payloadTypes.SET_SUPPLIER_ID,
        payload: {
          supplierId: newValue.value,
        },
      });
    } else {
      dispatch({
        type: payloadTypes.SET_SUPPLIER_ID,
        payload: {
          supplierId: 0,
        },
      });
    }
  };
  return (
    <>
      <SuppliersAutocomplete
        onChange={onChange ? onChange : handleChange}
        onKeyDown={onKeyDown ? onKeyDown : () => {}}
        value={value ? value : state.supplierId}
        autoFocus={autoFocus}
        label={label}
        forPo={forPo}
        input={input}
      />
      {icon && (
        <img
          src={DataFetch}
          alt=""
          onClick={() => setItemModal(!itemModal)}
          className="data-fetch-icon"
        />
      )}

      <Modal isOpen={itemModal} ariaHideApp={false} style={AddModalStyles}>
        <SuppliersList setModal={setItemModal} onSelect={handleChange} />
      </Modal>
    </>
  );
};

export default SuppliersSelect;
